import { useMutation } from '@tanstack/react-query';
import { KimLhcService } from '@/infra/services/kim-lhc';

interface UpdateStepAndCommentKimLhcParams {
	id: string;
	file_id: string;
	company_id: string;
	organization_id: string;
	step?: number;
	comment?: string;
}

const Service = KimLhcService.getInstance();

export const useUpdateStepAndCommentKimLhcReport = () => {
	return useMutation({
		mutationFn: async (params: UpdateStepAndCommentKimLhcParams) => await Service.update(params)
	});
};
